import { isDefined, isNonEmpty, isNotDefined } from '@sgme/fp';
import { useSgwtWidgets } from '@sgwt/sgwt-widgets-react';
import { FormattedMessage } from 'react-intl';

import { useUpdateUserPreferencesMutation } from '@/api/user/index.ts';
import { SgAmountInput } from '@/components/sg-design-system/components/input/SgAmountInput';
import { useAppSelector } from '@/store/hooks.ts';
import { getUserPreferences } from '@/store/userPreferences/slice.ts';
import { useDebounce } from '@/utils/hooks/debounce.ts';

const DefaultNotional = () => {
  const [updateUserPreferences] = useUpdateUserPreferencesMutation();
  const userPreferences = useAppSelector(getUserPreferences);

  const defaultNotional =
    isDefined(userPreferences.defaultNotional) && isNonEmpty(userPreferences.defaultNotional)
      ? Number(userPreferences.defaultNotional)
      : undefined;

  const { sgwtWebAnalytics } = useSgwtWidgets();

  const handleChange = useDebounce((value: number | undefined): void => {
    sgwtWebAnalytics?.trackEvent('Header', 'user preferences, cash tab, default notional');

    if (isNotDefined(defaultNotional) && isNotDefined(value)) {
      return;
    }

    updateUserPreferences({
      ...userPreferences,
      defaultNotional: isDefined(value) ? String(value) : null,
    });
  });

  return (
    <div className="d-flex align-items-center justify-content-between p-3 px-4 border-bottom">
      <label htmlFor="default-notional">
        <FormattedMessage id="userPreferences.label.defaultNotional" />
      </label>
      <div data-e2e="defaultNotional">
        <SgAmountInput
          size="md"
          data-e2e="defaultNotional-input"
          // id="default-notional"
          onChange={handleChange}
          value={defaultNotional}
        />
      </div>
    </div>
  );
};

export default DefaultNotional;
